import { Api } from 'api';
import { CRUDResponse } from 'api/interfaces/CRUDResponse';
import { Firm, FirmPayload, FirmType } from 'api/interfaces/firm';
import { isBusinessUnitsEnabled } from 'config/features';
import { Dispatch } from 'redux';
import { Action } from 'redux/action';
import { createAction } from 'redux/actions/creator';
import { ApplicationState } from 'redux/applicationState';
import { FirmsActions } from 'redux/reducers/firmsReducer';

export const createFirm =
  (firm: Firm) =>
  (
    dispatch: Dispatch<Action<FirmsActions>>,
    getState: () => ApplicationState,
    api: Api
  ): VoidFunction => {
    dispatch(createAction(FirmsActions.createFirmStarted));
    const state = getState();
    const selectedBusinessUnit = state.firms.selectedBusinessUnit;

    const useBusinessUnits = isBusinessUnitsEnabled && firm.firmType === FirmType.Connectivity;
    const payload = useBusinessUnits
      ? FirmPayload.fromFirmWithBU(firm, selectedBusinessUnit)
      : FirmPayload.fromFirm(firm);

    const task = useBusinessUnits ? api.createFirmWithBU(payload) : api.createFirm(payload);

    task
      .run()
      .then((result: CRUDResponse): void => {
        if (result.success) {
          dispatch(createAction(FirmsActions.createFirmCompleted, firm));
        } else {
          dispatch(createAction(FirmsActions.createFirmFailed, result.message));
        }
      })
      .catch((error: Error): void => {
        dispatch(createAction(FirmsActions.createFirmFailed, error.message));
      });

    return (): void => {
      task.cancel();
    };
  };
